window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  //Get URL Parameter
  function getUrlParameter(name) {
  	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  	var results = regex.exec(location.search);
  	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  //BG: if variant parameter is available in the URL, change the selection based on this.
  function changeProductByVariantID() {
  	var variantID= getUrlParameter('variant');
  	//console.log(variant);

      if (variantID) {
  		$('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
  		//console.log('test');
      }

  }
  
  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();




$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  //slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }


    $(document).on("click", ".canvas-menu .mobile-menus .mobile-nav ul li.has-children a.first-level",function() {
      console.log('Clicked Menu');
  		$(this).parent().find('ul').addClass('active');
      $(this).after( "<a href=\"#\" class=\"close\"></a>" );
      $('.canvas-menu .mobile-menus .mobile-nav ul li .close').show();
  	});

      $(document).on("click", ".close",function() {
        $('.canvas-menu .mobile-menus .mobile-nav ul li .close').hide();
      	$(this).nextAll('ul').removeClass('active');
        $( ".close" ).remove();
      });

  //product page swatch change
  $('.swatch :radio').change(function() {
  	var optionIndex = $(this).closest('.swatch').attr('data-option-index');
  	var optionValue = $(this).val();
  	$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
  });

  $('.swatch input').prop('checked', false);

  var accordionTitle = $('.accordion-title');

  $('.accordion-item.active .accordion-content').show();

	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {

			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();

			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})

      $('.search-icon').click(function(){
        $(".search-form").toggleClass('active');
        console.log('clicked');
      });
      $('.footer .col').click(function(){
        $(this).toggleClass('active');
      });
  $('.featured-products .products-list').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    cellAlign: 'left',
    autoPlay: true,
    freeScroll: true,
    pageDots: false,
    imagesLoaded: true
  });


  var optionsusp = {
    draggable: true,
    prevNextButtons: false,
    wrapAround: true,
    cellAlign: 'left',
    autoPlay: false,
    freeScroll: false,
    pageDots: false,
  };
  if ( matchMedia('screen and (min-width: 960px)').matches ) {
  //  optionsusp.autoPlay = false;
  }
  $('.header .usp-bar ul').flickity(optionsusp);
  $('.header .mobile-usp ul').flickity(optionsusp);
  $('.mobile-hero .slides').flickity(optionsusp);

        $('.search-icon').click(function(e){
          e.preventdefault();
          $(".search-form").toggleClass('active');
          console.log('clicked');
        });

  //Collection description more information toggle
  var productDescription = $('.collection-description'),
      productReadMore = $('.collection-read-more'),
      currentHeight = productDescription.height(),
      autoHeight = productDescription.css('height', 'auto').height(),
      showMoreText = 'Show More',
      showLessText = 'Show Less';

  productDescription.css('height', currentHeight);

  productReadMore.click(function(){
      if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          productDescription.removeClass('active');
          productDescription.height(currentHeight).animate({height: currentHeight}, 0);
          productReadMore.find('.text_more').html(showMoreText);
      } else {
          $(this).addClass('active');
          productDescription.addClass('active');
          productDescription.height(currentHeight).animate({height: autoHeight}, 0);
          productReadMore.find('.text_more').html(showLessText);
      }
  });

  $('.new-offer .close').click(function(e) {
    e.preventDefault();
    $('#shopify-section-new-offer').hide();
    localStorage['new-cust-offer'] = 'seen';
  });
  if(localStorage['new-cust-offer'] === 'seen'){
      $('#shopify-section-new-offer').hide();
  }
  if(localStorage['new-cust-offer'] !== 'seen'){
      $('#shopify-section-new-offer').show();
  }


  var $carousel = $('.product-detail-images .container').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true,
    cellAlign: 'left',
    imagesLoaded: true
  });

  var $carouselNav = $('.image-nav');
  var $carouselNavCells = $carouselNav.find('.product-image');

  $carouselNav.on( 'click', '.product-image', function( event ) {
    var index = $( event.currentTarget ).index();
    $carousel.flickity( 'select', index );
  });

  var flkty = $carousel.data('flickity');
  var navCellHeight = $carouselNavCells.height();
  var navHeight = $carouselNav.height();

  $carousel.on( 'select.flickity', function() {
    // set selected nav cell
    $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
    var $selected = $carouselNavCells.eq( flkty.selectedIndex )
      .addClass('is-nav-selected');
    // scroll nav
    var scrollY = $selected.position().top +
      $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
    $carouselNav.animate({
      scrollTop: scrollY
    });
  });



  $('.tabs').tabslet();
  $('.tabs').on("_after", function() {
    $('.featured-products .products-list').flickity('resize');
    $('.tabs .recent-products').flickity('resize');
  });


			$( document ).on( "beforecreate.offcanvas", function( e ){
				var dataOffcanvas = $( e.target ).data('offcanvas-component');
				console.log(dataOffcanvas);
				dataOffcanvas.onInit =  function() {
					console.log(this);
				};
			} );
			$( document ).on( "create.offcanvas", function( e ){
				var dataOffcanvas = $( e.target ).data('offcanvas-component');
				console.log(dataOffcanvas);
				dataOffcanvas.onOpen =  function() {
					console.log('Callback onOpen');
				};
				dataOffcanvas.onClose =  function() {
					console.log('Callback onClose');
				};

			} );
			$( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
				var dataBtnText = $( e.target ).text();
				console.log(e.type + '.' + e.namespace + ': ' + dataBtnText);
			} );
			$( document ).on( "open.offcanvas", function( e ){
				var dataOffcanvasID = $( e.target ).attr('id');
				console.log(e.type + ': #' + dataOffcanvasID);
        $('html, body').css({
          overflow: 'hidden',
          height: '100%'
        });
        document.ontouchmove = function (e) {
          e.preventDefault();
        }
        var fixed = document.getElementById('fixed');
        fixed.addEventListener('touchmove', function(e) {
                e.preventDefault();
        }, false);
			} );
			$( document ).on( "resizing.offcanvas", function( e ){
				var dataOffcanvasID = $( e.target ).attr('id');
				console.log(e.type + ': #' + dataOffcanvasID);
			} );
			$( document ).on( "close.offcanvas", function( e ){
				var dataOffcanvasID = $( e.target ).attr('id');
				console.log(e.type + ': #' + dataOffcanvasID);
        $('html, body').css({
            overflow: 'visible',
            height: 'auto'
        });
        document.ontouchmove = function (e) {
          return true;
        }
			} );
			$( document ).on( "destroy.offcanvas", function( e ){
				var dataOffcanvasID = $( e.target ).attr('id');
				console.log(e.type + ': #' + dataOffcanvasID);
			} );
			$( '#top' ).on( "create.offcanvas", function( e ){
				var api = $(this).data('offcanvas-component');

                console.log(api);
				$('.js-destroy').on('click', function () {
					api.destroy();
                    //$( '#top' ).data('offcanvas-component').destroy();
					console.log(api);
					console.log( $( '#top' ).data() );
				});
			} );

			$( '#left' ).offcanvas( {
				modifiers: "left,overlay",
				triggerButton: '.js-left'
			} );
			$( '#right' ).offcanvas( {
				modifiers: "right,overlay",
				triggerButton: '.js-left'
			} );


			$('.js-enhance').on('click', function () {
				console.log('enhance');
				$( document ).trigger( "enhance" );
			});

			$( document ).trigger( "enhance" );



  $(document).on("click", ".s-close",function() {
    $('.search-form').hide();
  });

  $(document).on("click", ".right a",function() {
    $('.filter-button-group').show();
  });




        $(document).on("click", ".filter-action a",function(e) {
      		e.preventDefault();
          console.log('clickfilter');
          $("#bc-sf-filter-tree-mobile-button").trigger('click');
          $("#bc-sf-filter-tree-mobile-button").trigger('touchstart');
        });


        $(document).on("click", ".sort-action a",function(e) {
      		e.preventDefault();
          console.log('clicksort');
          $("#bc-sf-filter-top-sorting").toggle();
        });

  $(document).on("click", ".filter-button-group .button",function() {
    $('.filter-button-group').hide();
    if ($(this).data('shortname')) {
      var countryname = $(this).data('shortname');
    } else {
      var countryname = $(this).text();
    }
    $('.delivery-page .container .page-content .delivery-location .delivery-wrap .left h2').html(countryname);
    if ($(this).data('flag')) {
      var newSrc = $(this).data('flag');
      $('.delivery-page .container .page-content .delivery-location .delivery-wrap .left .flag img').attr('src', newSrc);
    } else {
      $('.delivery-page .container .page-content .delivery-location .delivery-wrap .left .flag').hide();
    }
  });




  $('.swatch label').click(function(e){
      var clickedvariant = $(this).parent().attr('data-variant-id');
      console.log(clickedvariant);
      $('#BIS_trigger').attr('data-variant-id', clickedvariant);
  });

  var soldOutBtn = $('.btn-add-to-cart.variant-not-available'),
      notifyBtn = $('#BIS_trigger');

      soldOutBtn.click(function(e){
        e.preventDefault();
        notifyBtn.click();
      });






	$('.metric-toggle li').click(function(){
		$('.metric-toggle li').removeClass('active');
		$(this).addClass('active');

    var sizemetric = $('.metric-toggle li.active').text();

    if(sizemetric=="CM"){
      $('.size-table tr td .metric').each(function () {
        console.log($(this).data('original'));
        function roundHalf(num) {
            return Math.round(num*2)/2;
        }
        var sizecm = $(this).data('original')*2.54;
        $(this).text(roundHalf(sizecm));
      });
    }
    if(sizemetric=="Inches"){
      $('.size-table tr td .metric').each(function () {
        $(this).text($(this).data('original'));
      });
    }
	});



    $('.sizeguide-link').click(function(){
      $('.product-sizeguide-overlay').addClass('active');
      $('.product-sizeguide').addClass('active');
    });
    $('.product-sizeguide .frame-close').click(function(){
      $('.product-sizeguide-overlay').removeClass('active');
      $('.product-sizeguide').removeClass('active');
    });
    $('.product-sizeguide-overlay').click(function(){
      $('.product-sizeguide-overlay').removeClass('active');
      $('.product-sizeguide').removeClass('active');
    });






    $('.region-toggle li').click(function(){
      $('.region-toggle li').removeClass('active');
      $(this).addClass('active');

      var region = $('.region-toggle li.active').text();

      $('.size-table tr td.region-name').text(region);

      if(region=="EU"){
        $('.size-table tr td.size').each(function () {
          if ($(this).data('original') == '6') {
              $(this).text('34');
          }
          if ($(this).data('original') == '8') {
              $(this).text('36');
          }
          if ($(this).data('original') == '10') {
              $(this).text('38');
          }
          if ($(this).data('original') == '12') {
              $(this).text('40');
          }
          if ($(this).data('original') == '14') {
              $(this).text('42');
          }
        });
      }

      if(region=="US"){
        $('.size-table tr td.size').each(function () {
          if ($(this).data('original') == '6') {
              $(this).text('2');
          }
          if ($(this).data('original') == '8') {
              $(this).text('4');
          }
          if ($(this).data('original') == '10') {
              $(this).text('6');
          }
          if ($(this).data('original') == '12') {
              $(this).text('8');
          }
          if ($(this).data('original') == '14') {
              $(this).text('10');
          }
        });
      }

      if(region=="AU"){
        $('.size-table tr td.size').each(function () {
          $(this).text($(this).data('original'));
        });
      }
      if(region=="UK"){
        $('.size-table tr td.size').each(function () {
          $(this).text($(this).data('original'));
        });
      }
    });



  /*
    if ($(this).text() == '6') {
        $(this).text('78.5');
    }
    if ($(this).text() == '8') {
        $(this).text('81');
    }
    if ($(this).text() == '10') {
        $(this).text('86');
    }
    if ($(this).text() == '12') {
        $(this).text('91');
    }
    if ($(this).text() == '14') {
        $(this).text('96');
    }*/

});
$(window).bind("load", function() {

    var Scrollbar = window.Scrollbar;

    Scrollbar.init(document.querySelector('.scrollcontent'));
    Scrollbar.init(document.querySelector('.cart-mini-contents'));

  $('.featured-products-slick').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true,
    pageDots: false,
    imagesLoaded: true
  });
  $('.latest-insta .right .ig-slides ul').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: true,
    pageDots: false,
    imagesLoaded: true
  });
  $('.menu-scroller ul').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    lazyLoad: true,
    lazyLoad: 3,
    autoPlay: true,
    pageDots: false,
    imagesLoaded: true
  });
  $('.blog-featured').flickity({
    // options
    draggable: '>1',
    prevNextButtons: false,
    wrapAround: true,
    cellAlign: 'center',
    autoPlay: true,
    freeScroll: true,
    pageDots: false,
    imagesLoaded: true
  });





      $(".ss-toolbar").stick_in_parent();

        console.log('start count');

        $('.result').each(function () {
          console.log(this);(this).find('.webyze-pc-swatches');
        var parentContainerWidth = $(this).find('.webyze-pc-swatches').width();
        var elementCount = $(this + '.swatch').filter(function() {
          return $(this).offset().left >= parentContainerWidth;
        }).length;
        console.log('Hidden Count: '+elementCount);
      });

        var soldOutLabel = $('.soldout > label'),
            notifyBtn = $('#BIS_trigger');

            soldOutLabel.click(function(e){
              e.preventDefault();
              notifyBtn.click();
        });
});
